





































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Container, Draggable } from 'vue-smooth-dnd';

@Component({
    components: {
        Container,
        Draggable
    }
})
export default class DeductionForm extends Vue {
    @Prop() data: CommonTypes.mapObject[];
    tableData: CommonTypes.mapObject[] = [];

    @Watch('data', { immediate: true, deep: true })
    getDataChanged() {
        this.tableData = Object.assign([], this.data);
    }
    async addDeductionItem() {
        await this.validateDeduction();
        this.tableData.push({
            name: '',
            value: 10,
            desc: '',
            valueType: 'NUMERIC',
            fieldType: 'CUSTOM'
        });
    }

    validateDeduction() {
        // 判断当前 tableData 中必填的扣分项有没有填写
        return new Promise((resolve, reject) => {
            this.tableData.forEach((item, index) => {
                if (!item.name) {
                    this.$set(this.tableData[index], 'showTip', true);
                    reject(new Error('请完成必填项'));
                }
            });
            resolve('');
        });
    }
    handleDelete(index: number) {
        this.tableData.splice(index, 1);
        this.emitChange();
    }
    onDrop(result: any) {
        const { removedIndex, addedIndex } = result;
        const lableList = this.tableData;
        const keyLable = lableList[removedIndex];
        lableList.splice(removedIndex, 1);
        lableList.splice(addedIndex, 0, keyLable);
        this.tableData = lableList;
        this.emitChange();
    }
    handleChange(index: number, type: string, val?: any) {
        if (this.tableData[index] && this.tableData[index].id) delete this.tableData[index].id;
        if (type === 'name') this.tableData[index].showTip = !val;
        this.emitChange();
    }
    emitChange() {
        this.$emit('change', this.tableData);
    }
}
